import { CSRF_TOKEN_COOKIE_NAME, Header } from "./constants.js";
function buildRequestHeader({ version, defaultHeaders, requestFormat }) {
    const csrfCookieValue = getCookieValue(CSRF_TOKEN_COOKIE_NAME);
    return {
        ...'JSON' === requestFormat ? {
            'Content-Type': 'application/json'
        } : {},
        Accept: 'application/json',
        ...defaultHeaders,
        ...version ? {
            [Header.WebAppVersion]: version
        } : {},
        ...csrfCookieValue ? {
            [Header.CSRF]: csrfCookieValue
        } : {},
        ...getGlobalHeaders()
    };
}
function getCookieValue(name) {
    for (const cookieSegment of document.cookie.split(/;\s*/))if (cookieSegment.includes(`${name}=`)) return cookieSegment.replace(`${name}=`, '');
    return null;
}
function getGlobalHeaders() {
    if (!globalThis.GlobalHeaders || 'object' != typeof globalThis.GlobalHeaders) return {};
    const globalHeaders = {
        ...globalThis.GlobalHeaders
    };
    for(const property in globalHeaders)if (null == globalHeaders[property]) delete globalHeaders[property];
    return globalHeaders;
}
export { buildRequestHeader, getCookieValue };
